import React, { useState } from 'react'
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '../../ui/alert-dialog'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import { Label } from '../../ui/label'
import { useMutation, useQuery } from 'react-query'
import axios from 'src/axios/axios'
import useAuth from 'src/hooks/useAuth'
import { Loader2 } from 'lucide-react'
import { Textarea } from 'src/components/ui/textarea'
import toast from 'react-hot-toast'
import { Item, MultiSelect } from 'src/components/ui/multiselect'
import { useTranslation } from 'react-i18next'
import { Switch } from 'src/components/ui/switch'

type Props = {
    onSuccess?: () => void
    docid: number
}

const AddMessage = ({onSuccess, docid}:Props) => {
    const { t, i18n } = useTranslation()

    const { auth } = useAuth()
    const [title, settitle] = useState('');
    const [message, setmessage] = useState('');
    const [selected_users, setselected_users] = useState<Item[]>([]);
    const [auto_close, setauto_close] = useState<boolean>(false);

    const { mutate, reset, isLoading } = useMutation({
        mutationFn: async () => {
            try {
                const body = {
                    docid: docid,
                    title: title,
                    message: message,
                    users: selected_users.map(u=>({username:u.value})),
                    state: auto_close ? 2 : 1
                }
                const { data } = await axios.post(`communications/header/add`, body)
                if(data.errorcode!==0){ throw new Error(data.message) }
                reset();
                settitle(''); setmessage(''); setselected_users([]); setauto_close(false)
                onSuccess && onSuccess()
            } catch (error) {
                
            }
        }
    })

    const { data:colleges } = useQuery<ForwardUser[] | null>({
        queryKey: [`colleges`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`users/get`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                if(!Array.isArray(data.object.users)){ throw new Error('users is no array') }
                
                let users = data.object.users.filter((i:ForwardUser)=>!i.blocked)
                return users
            } catch (error) {
                toast.error(`${t('Collegas ophalen mislukt')}`, {id:'colleges'})
                return null
            }
        }
    })

  return (
    <AlertDialog>
        <AlertDialogTrigger asChild><Button disabled={isLoading} size='sm' className='gap-2'>{isLoading && <Loader2 className='w-4 h-4 animate-spin'/>}{t('Nieuw bericht')}</Button></AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{t('Bericht toevoegen')}</AlertDialogTitle>
                <AlertDialogDescription>{t('Vul onderstaande velden in om uw bericht op te slaan')}</AlertDialogDescription>
            </AlertDialogHeader>
            <div>
                <div>
                    <Label htmlFor='title'>{t('Titel')}</Label>
                    <Input value={title} onChange={({currentTarget})=>{settitle(currentTarget.value)}} placeholder={`${t('Titel')}...`} id='title'/>
                </div>
                <div>
                    <Label htmlFor='message'>{t('Bericht')}</Label>
                    <Textarea value={message} onChange={({currentTarget})=>{setmessage(currentTarget.value)}} placeholder={`${t('Typ uw bericht')}...`} id='message'/>
                </div>
                <div>
                    <Label htmlFor='message'>{t('Gebruikers')}</Label>
                    <MultiSelect onValueChange={(vs)=>{setselected_users(vs)}} selectedValue={selected_users} options={Array.isArray(colleges) ? colleges.map((c)=>({value:c.username, label:`${c.firstname} ${c.name}`})) : []} placeholder={`${t('Selecteer een collega')}...`}/>
                </div>
                <div className='flex items-center gap-1'>
                    <Switch checked={auto_close} onCheckedChange={(c)=>{setauto_close(c)}}/>
                    <Label>{t('Automatisch sluiten')}</Label>
                </div>
            </div>
            <AlertDialogFooter>
                <AlertDialogCancel>{t('Annuleren')}</AlertDialogCancel>
                <AlertDialogAction disabled={title.length < 1 || message.length < 1} onClick={()=>{mutate()}}>{t('Opslaan')}</AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default AddMessage